export default "__VITE_PUBLIC_ASSET__4c864d50__"